import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { ActiveUserData } from 'src/types/combinedUserData';

export interface GetAllUsersResponse {
  success: boolean;
  users: ActiveUserData[];
  scimEnabledTenantIds?: string[];
}

export const _mockUsersData: GetAllUsersResponse = {
  success: true,
  scimEnabledTenantIds: ['tenant1'],
  users: [
    {
      id: 'user1',
      tenantId: 'tenant1',
      firstName: 'John',
      lastName: 'Doe',
      email: 'john.doe@example.com',
      authProvider: 'keycloak',
      lastLogin: new Date().toISOString(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      profilePicPath: '',
      profilePictureUrl: '',
      roles: ['user'],
      userRoles: [],
      allowedTenants: [],
      externalEncompassId: 'encompass-user-1',
      scimExternalId: 'scim-user-1',
      scimUserName: 'john.doe@example.com',
      scimActive: true,
      scimDeprovisionedAt: null,
      scimProvisionedAt: new Date().toISOString(),
    },
    {
      id: 'user2',
      tenantId: 'tenant1',
      firstName: 'Jane',
      lastName: 'Smith',
      email: 'jane.smith@example.com',
      authProvider: 'keycloak',
      lastLogin: new Date().toISOString(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      profilePicPath: '',
      profilePictureUrl: '',
      roles: ['user'],
      userRoles: [],
      allowedTenants: [],
      externalEncompassId: null,
      scimExternalId: 'scim-user-2',
      scimUserName: 'jane.smith@example.com',
      scimActive: false,
      scimDeprovisionedAt: new Date().toISOString(),
      scimProvisionedAt: new Date().toISOString(),
    },
  ],
};

const getAllUsers: QueryFunction<
  GetAllUsersResponse,
  ['/shared/users', undefined]
> = async () => {
  if (isMockServices()) return await mock(_mockUsersData);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetAllUsersResponse>('/shared/users', {
    method: 'GET',
  });
  if (response.data) return response.data;
  throw new Error('Failed to fetch users');
};

export default getAllUsers;
